var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7499 4.24999C12.617 4.1172 12.4369 4.0426 12.2491 4.0426C12.0613 4.0426 11.8811 4.1172 11.7483 4.24999L8.49987 7.49841L5.25145 4.24999C5.11862 4.1172 4.93849 4.0426 4.75066 4.0426C4.56284 4.0426 4.3827 4.1172 4.24987 4.24999C4.11708 4.38283 4.04248 4.56296 4.04248 4.75078C4.04248 4.93861 4.11708 5.11874 4.24987 5.25158L7.49829 8.49999L4.24987 11.7484C4.11708 11.8812 4.04248 12.0614 4.04248 12.2492C4.04248 12.437 4.11708 12.6172 4.24987 12.75C4.3827 12.8828 4.56284 12.9574 4.75066 12.9574C4.93849 12.9574 5.11862 12.8828 5.25145 12.75L8.49987 9.50158L11.7483 12.75C11.8811 12.8828 12.0613 12.9574 12.2491 12.9574C12.4369 12.9574 12.617 12.8828 12.7499 12.75C12.8827 12.6172 12.9573 12.437 12.9573 12.2492C12.9573 12.0614 12.8827 11.8812 12.7499 11.7484L9.50145 8.49999L12.7499 5.25158C12.8827 5.11874 12.9573 4.93861 12.9573 4.75078C12.9573 4.56296 12.8827 4.38283 12.7499 4.24999Z",
    fill: "#F80000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.5018991acc58b851c462336e5e365d5f.svg";
export { ForwardRef as ReactComponent };